function getActiveDiscount(dicounts, itemsPrice) {
    let result = null;
    for (const discount of dicounts) {
        if (discount.min_order_price <= itemsPrice && (!result || discount.min_order_price > result.discount))
            result = discount;
    }
    return result;
}
function getAvailableDiscounts(dicounts, itemsPrice) {
    let result = [];
    const activeDiscount = getActiveDiscount(dicounts, itemsPrice);
    if (activeDiscount)
        result.push(activeDiscount);
    for (const discount of dicounts) {
        if (discount.min_order_price > itemsPrice)
            result.push(discount);
    }
    return result;
}
export function computeAvailablePaymentShipment(state) {
    let resultPayments = [];
    // filter by reuqired by items
    const onlyPossibleShipments = state.cart.items.map((item) => item.shipments).flat();
    for (const payment of state.cart.payments) {
        let resultShipments = [];
        for (const shipment of payment.shipments) {
            // TODO skip packeta for now
            if (shipment.id === 15)
                continue;
            // if shipment is not supported by any item, skip it
            if (onlyPossibleShipments.length > 0 && !onlyPossibleShipments.includes(shipment.id))
                continue;
            // add if treshold is not 0 and shipment total price is higher than treshold
            if (shipment.free_shipping_threshold > 0 && state.totalItemsPriceWithDiscount > shipment.free_shipping_threshold) {
                resultShipments.push({ ...shipment, finalPrice: 0 });
            }
            else if (shipment.type === 'price') {
                resultShipments.push({ ...shipment, finalPrice: shipment.price });
            }
            else if (shipment.type === 'price_order_sum') {
                const temp = shipment.price_order_sum.find((price) => price.from <= state.totalItemsPriceWithDiscount && state.totalItemsPriceWithDiscount <= price.to);
                if (temp)
                    resultShipments.push({ ...shipment, finalPrice: temp.price });
            }
            else if (shipment.type === 'price_weight') {
                const temp = shipment.price_weight.find((weight) => weight.from <= state.totalItemsWeight && state.totalItemsWeight <= weight.to);
                if (temp)
                    resultShipments.push({ ...shipment, finalPrice: temp.price });
            }
        }
        // if there is no shipment, skip payment
        if (resultShipments.length === 0)
            continue;
        const availableDiscounts = getAvailableDiscounts(payment.discounts, state.totalItemsPriceWithDiscount);
        resultPayments.push({
            ...payment,
            discounts: availableDiscounts,
            shipments: resultShipments,
        });
    }
    return resultPayments;
}
